import { Button } from 'rsuite';
import styled from 'styled-components';
import { cssVars } from '../../../app/styles';
import {
  GANTT_TIMELINE_VERTICAL_PADDING_PX,
  SEPARATOR_HEIGHT,
  SWIMLANE_LABEL_PADDING_TOP,
  SWIMLANE_LABEL_PANE_WIDTH,
} from '../../constants';
import {
  MonthContainer,
  MonthHeader,
  MonthTitle,
} from '../calendar-month/styles';
import { DailyCalendarGrid } from '../daily-calendar/styles';

export const ResetButton = styled(Button)`
  & > span {
    padding: 0 10px;
  }
`;

export const TimelineLabel = styled.div`
  text-align: right;
  padding: ${GANTT_TIMELINE_VERTICAL_PADDING_PX}px 20px;
  text-transform: uppercase;
  font-weight: bold;
`;

export const StyledMonthContainer = styled(MonthContainer)`
  height: 100%;
  width: ${SWIMLANE_LABEL_PANE_WIDTH};
  padding: 0;
  position: absolute;
`;

export const StyledMonthHeader = styled(MonthHeader)`
  padding-right: 0;
  padding-left: 0;
`;

export const StyledMonthTitle = styled(MonthTitle)`
  justify-content: flex-end;
  padding-right: 20px;
  padding-left: 0;
`;

export const StyledDailyCalendarGrid = styled(DailyCalendarGrid)`
  background: ${cssVars.propertyHistoryColors.swimlaneLabelPaneBg};
  border-bottom: ${SEPARATOR_HEIGHT} solid #fff;
  margin-right: 0;
`;

export const ReviewsLabel = styled.div`
  flex: 1;
  background: ${cssVars.propertyHistoryColors.swimlaneLabelPaneBg};
  padding-top: 10px;
`;
